import am4lang_en_US from "@amcharts/amcharts4/lang/en_US";
import am4lang_ru_RU from "@amcharts/amcharts4/lang/ru_RU";
import {parse, format} from "date-fns";
import i18n from "@/lang/i18n";

export default {
    install(Vue) {
        Vue.mixin({
            data() {
                return {
                    delay: (function(){
                        let timer = 0;
                        return function(callback, ms){
                            clearTimeout(timer);
                            timer = setTimeout(callback, ms);
                        };
                    })()
                }
            },
            methods: {
                findItem(items, id, field) {
                    if (field === undefined) field = 'name';
                    let item = items.find(v => v.id === id);
                    return item !== undefined ? item[field] : null;
                },
                setLang(chart) {
                    switch (this.$store.state.user.lang) {
                        case 'en':
                            chart.language.locale = am4lang_en_US;
                            break;
                        case 'ru':
                            chart.language.locale = am4lang_ru_RU;
                            break;
                        default:
                            chart.language.locale = am4lang_en_US;
                    }
                },
                timeLocalToUtc(time) {
                    if (time === null) return null;
                    if (typeof time === 'object') return time.toISOString();
                    let d = parse(time, 'yyyy-MM-dd HH:mm:ss', new Date());
                    return d.toISOString();
                },
                timeLocalToServer(time) {
                    if (time === null) return null;
                    return format(time, 'yyyy-MM-dd')+'T'+format(time, 'HH:mm:ss')+'Z';
                },
                timeUtcToLocal(time) {
                    if (time === null) return null;
                    let d = new Date(time);
                    return format(d, 'yyyy-MM-dd HH:mm:ss');
                },
                timeUtcToLocalObj(time) {
                    if (time === null) return null;
                    return new Date(time);
                },
                timeServerToLocal(date) {
                    if (date === undefined || date === null) return null;
                    let source = date.slice(0, 10) + ' ' + date.slice(11, 19);
                    return parse(source, 'yyyy-MM-dd HH:mm:ss', new Date());
                },
                dateLocalToServer(date) {
                    if (date === null) return null;
                    if (typeof date === 'string') {
                        date = parse(date, 'yyyy-MM-dd', new Date());
                    }
                    return format(date, 'yyyy-MM-dd')+'T00:00:00Z';
                },
                dateServerToLocal(date) {
                    if (date === undefined || date === null) return null;
                    let source = date.slice(0, 10);
                    return parse(source, 'yyyy-MM-dd', new Date());
                },
                dateServerToLocalStr(date) {
                    if (typeof date !== 'string') return null;
                    return date.slice(0, 10);
                },
                yearMonthWeekDay(countDays) {

                    let retFunc = (year, month, week, day) => {
                        var ret = '';

                        if (year > 0) {
                            ret += '<span>'  + year + '</span> ' + this.$tc('msg.yearTc', year);
                        }

                        if (month > 0) {
                            if (ret !== '') ret += ' ';
                            ret += '<span>'  + month + '</span> ' + this.$tc('msg.monthTc', month);
                        }

                        if (week > 0) {
                            if (ret !== '') ret += ' ';
                            ret += '<span>'  + week + '</span> ' + this.$tc('msg.weekTc', week);
                        }

                        if (day > 0) {
                            if (ret !== '') ret += ' ';
                            ret += '<span>'  + day + '</span> ' + this.$tc('msg.dayTc', day);
                        }

                        return ret;
                    };

                    let year = 0;
                    let month = 0;
                    let week = 0;

                    if (countDays >= 365) {
                        year = Math.trunc(countDays / 365)
                        countDays -= year * 365
                    }

                    if (countDays >= 30) {
                        month = Math.trunc(countDays / 30)
                        countDays -= month * 30
                    }

                    if (countDays >= 7) {
                        week = Math.trunc(countDays / 7)
                        countDays -= week * 7
                    }

                    return retFunc(year, month, week, countDays);
                },
                hourMonth(seconds) {

                    let minutes = seconds / 60;

                    let retFunc = (hours, minutes) => {
                        var ret = '';

                        if (hours > 0) {
                            ret += '<span>'  + hours + '</span> ' + this.$t('msg.h');
                        }

                        if (minutes > 0) {
                            if (ret !== '') ret += ' ';
                            ret += '<span>'  + minutes + '</span> ' + this.$t('msg.m');
                        }
                        return ret;
                    };

                    let hours = 0;

                    if (minutes >= 60) {
                        hours = Math.trunc(minutes / 60)
                        minutes -= hours * 60
                    }

                    return retFunc(hours, minutes);
                },
                cMonthFormat(month) {

                    let parts = month.split('-');

                    if (parts.length !== 2) return month;

                    let m = parseInt(parts[1]);

                    return this.$t('month.'+m)+' '+parts[0];
                },
                firstUpperCase(str) {
                    return str[0].toUpperCase() + str.substring(1);
                },
                recountSequenceModels(models, sequenceModels, event) {

                    let fromSeq = sequenceModels[event.moved.oldIndex].sequence;
                    let toSeq = sequenceModels[event.moved.newIndex].sequence;

                    // console.log(fromSeq, toSeq)

                    let from = fromSeq;
                    let to = toSeq;
                    let isInvert = false;

                    if (fromSeq > toSeq) {
                        from = toSeq
                        to = fromSeq
                        isInvert = true;
                    }

                    models.forEach(model => {
                        if (!isInvert && model.sequence > from && model.sequence <= to) {

                            model.sequence = model.sequence - 1;

                        } else if (isInvert && model.sequence >= from && model.sequence < to) {

                            model.sequence = model.sequence + 1;

                        } else if (model.sequence === fromSeq) {

                            model.sequence = toSeq;
                        }
                    });

                    // console.log(models[event.moved.oldIndex].sequence, models[event.moved.newIndex].sequence)

                    return {
                        models,
                        id: event.moved.element.id,
                        from: fromSeq,
                        to: toSeq,
                    };
                },
                logout() {
                    if (!confirm(this.$t('msg.logout')+'?')) return;

                    this.$store.dispatch('logout')
                        .then(() => {
                            this.$store.commit('setLogin', 'false');
                            this.$router.push({name: 'index'});
                        });
                },
                dateString(dateString) {
                    if (typeof dateString !== 'string') return null;
                    dateString = dateString.substring(0, 10);
                    let date = parse(dateString, 'yyyy-MM-dd', new Date())
                    return format(date, 'd') + ' ' +
                        i18n.t('monthShort.'+format(date, 'MMMM')) + ' ' +
                        format(date, 'yyyy');
                }
            },
            computed: {
                isMobile() {
                    return this.$vuetify.breakpoint.xs;
                },
            }
        })
    }
}